// pending-changes.guard.ts
import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfirmationService } from '~ngx-shared/layout';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean;
}

export function leaveGuard(): CanDeactivateFn<CanComponentDeactivate> {
  return (component, currentRoute) => {
    if (component.canDeactivate()) {
      return true;
    }

    const confirmationService = inject(ConfirmationService);
    return new Observable(observer => {
      confirmationService.confirm(
        () => {
          observer.next(true);
          observer.complete();
        },
        () => {
          observer.next(false);
          observer.complete();
        }
      );
    });
  };
}
